import React from 'react';
import PropTypes from 'prop-types';

import Navigation from 'pages/navigation';
import LoadingPage from 'refactored/pages/loadingPage';

const App = ({ isLoading, history }) => {
  return isLoading ? <LoadingPage /> : <Navigation history={history} />;
};

App.propTypes = {
  isLoading: PropTypes.bool,
  history: PropTypes.any,
};

App.defaultProps = {
  history: {},
};

export default App;
